// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__E6kvG","box":"styles_box__qw-eX","defectRow":"styles_defectRow__A0DHN","approval":"styles_approval__feHcT","fromBooking":"styles_fromBooking__9eL2p"};